import { render, staticRenderFns } from "./jd-button.vue?vue&type=template&id=557a44d6&scoped=true"
import script from "./jd-button.vue?vue&type=script&lang=js"
export * from "./jd-button.vue?vue&type=script&lang=js"
import style0 from "./jd-button.vue?vue&type=style&index=0&id=557a44d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557a44d6",
  null
  
)

export default component.exports